import React from "react";
import { Grid } from "@mui/material";
import LinkedSocialPage from "./NoticeboardLinkedSocialItems";
import { LottieLoadingIndicator, Text } from "src/components";
import moment from "moment";
import { SocialMediaPlatform } from "./AccountLinking/utils/Enums";
import { POST_TYPE } from "../constants";
import { isSocialAccountExpired } from "./AccountLinking/utils/socialAccountExpiry";

const LinkedSocialsGroup = ({
    linkedPlatformItems,
    showEditMessage,
    onToggleSocialItem,
    selectedSocialsUuids,
    postedTo,
    isEditForm,
    scheduleDateInTheFuture
}) => {
    return (
        <Grid container direction="row" spacing={1} style={{ paddingBottom: "4px" }}>
            {
                linkedPlatformItems.map((platformItem) => {
                    const platformType = platformItem.pageAdmin.socialMediaType;
                    const isExpired = isSocialAccountExpired(platformItem);
                    return platformItem.pages.map((pageItem, index) => {
                        const isPageSelected = selectedSocialsUuids && selectedSocialsUuids.some((item) => {
                            return item === pageItem.uuid;
                        });
                        const isPosted = postedTo && postedTo.find((item) => item.pageUuid === pageItem.uuid);
                        return (
                            <Grid key={index} item>
                                <LinkedSocialPage
                                    pageName={pageItem.pageName}
                                    pagePhoto={pageItem.pagePhoto}
                                    pagePlatformType={platformType}
                                    pageUuid={pageItem.uuid}
                                    onToggle={onToggleSocialItem}
                                    checked={isPageSelected}
                                    isPosted={isPosted}
                                    isEditForm={isEditForm}
                                    scheduleDateInTheFuture={scheduleDateInTheFuture}
                                    showToggleSwitch={!showEditMessage}
                                    isExpired={isExpired}
                                />
                            </Grid>
                        );
                    });
                })
            }
        </Grid>
    );
};

const NoticeModalSocialPlatform = ({
    linkedAccounts,
    linkedAccountsFetched,
    onToggleSocialItem,
    selectedSocialsUuids,
    postedTo,
    isEditForm,
    scheduleDate,
    postType
}) => {
    const now = moment();
    const scheduleDateInTheFuture = moment(scheduleDate).isAfter(moment(now));
    const showEditMessage = !scheduleDateInTheFuture && isEditForm;
    const platforms = [SocialMediaPlatform.FACEBOOK, SocialMediaPlatform.INSTAGRAM, SocialMediaPlatform.LINKEDIN];

    const linkedInstagramPages = linkedAccounts[SocialMediaPlatform.INSTAGRAM] || [];
    const allPages = linkedInstagramPages.flatMap(admin => admin.pages);

    const showInstagramNote = isEditForm ?
        (allPages.filter(page =>
            selectedSocialsUuids.includes(page.uuid)
        ).length > 0)
        : false;

    if (!linkedAccountsFetched) {
        return <LottieLoadingIndicator />;
    }

    return (
        <>
            {
                showEditMessage && showInstagramNote &&
                <Text size="1rem" align="left">
                    Changes made here will not be reflected on a post that is live on Instagram. Please update directly on that platform as needed.
                </Text>
            }
            {
                platforms.map((platform, index) => {
                    const accounts = linkedAccounts[platform];
                    if (!accounts || accounts.length === 0) {
                        return null;
                    }
                    const carouselSupported = platform === SocialMediaPlatform.INSTAGRAM;
                    if (postType === POST_TYPE.CAROUSEL && !carouselSupported) {
                        return null;
                    }
                    return (
                        <div key={index}>
                            <LinkedSocialsGroup
                                linkedPlatformItems={accounts}
                                showEditMessage={showEditMessage}
                                onToggleSocialItem={onToggleSocialItem}
                                selectedSocialsUuids={selectedSocialsUuids}
                                postedTo={postedTo}
                                isEditForm={isEditForm}
                                scheduleDateInTheFuture={scheduleDateInTheFuture}
                            />
                        </div>
                    );
                })
            }
        </>
    );
};

export default NoticeModalSocialPlatform;